
  import {Component, Vue} from 'vue-property-decorator';

    @Component({
        props: {
            count: Number,
            take: Number,
            page: Number,
            totalCount: Number
        }
    })
    export default class TablePager extends Vue {
        get end() {
            return Math.ceil(this.$props.totalCount / this.$props.take) || 0;
        }

        private onClickChangePage(page: Number) {
            this.$emit('changePage', page);
        }
    }
